import { Empty, EmptyProps } from "antd";
import imgUrl from './empty.svg';

const defaultImage = (
  <img
    src={imgUrl}
    alt=""
    style={{ display: 'block', margin: '0 auto' }}
  />
);

export const ThEmpty: React.FC<EmptyProps> = (props) => {
  const { image = defaultImage, style, ...otherProps } = props;

  return (
    <Empty
      {...otherProps}
      style={{ margin: 0, ...style }}
      image={image}
    />
  );
};